import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TruncatePipe } from './truncate.pipe';
import { CurrencyFormatPipe } from './currency-format.pipe';
import { CurrencyFormatLsmPipe } from './currency-format-lsm.pipe';

@NgModule({
    declarations: [TruncatePipe, CurrencyFormatPipe, CurrencyFormatLsmPipe],
    imports: [
        CommonModule
    ],
    exports: [TruncatePipe, CurrencyFormatPipe, CurrencyFormatLsmPipe]
})
export class PipesModule {
    static forRoot(): ModuleWithProviders<PipesModule> {
        return {
            ngModule: PipesModule,
            providers: [],
        };
    }
}